module.exports = "/assets/img/author-feature-3.b66cf770.jpg";